const testidSeparators = {
  EXPERIMENTS_SEPARATOR: '^',
  KBB_TESTID_VARIATION_SEPARATOR: '_',
  PE_TESTID_VARIATION_SEPARATOR: '-'
};
const getTestAndVariationValue = function (testAndVariation, separator) {
  const gaTestAndVariation = testAndVariation?.split(separator);
  if (gaTestAndVariation && gaTestAndVariation.length === 2 && gaTestAndVariation[0] && gaTestAndVariation[1]) {
    return gaTestAndVariation.join('::').toLowerCase();
  }
  return null;
};
export const getExperimentIds = function (testIds) {
  if (!testIds || typeof testIds !== 'string') {
    return [];
  }
  const experiments = testIds.split(testidSeparators.EXPERIMENTS_SEPARATOR).map(testAndVariation => {
    return getTestAndVariationValue(testAndVariation, testidSeparators.PE_TESTID_VARIATION_SEPARATOR) || getTestAndVariationValue(testAndVariation, testidSeparators.KBB_TESTID_VARIATION_SEPARATOR);
  }).filter(testAndVariation => testAndVariation);
  if (experiments && experiments.length > 0) {
    return experiments;
  }
  return [];
};